import axios from 'axios';
import jquery from 'jquery';
import {
    createAxiosResponseInterceptor,
    GoogleRecaptcha,
} from 'paysera-recaptcha-modal';

import { loggerFactory } from '@assetsJsModule/logger';
import i18next from '@assetsJsModule/i18next';

const logger = loggerFactory('recaptcha-axios-interceptor');

const createInterceptor = async () => {
    try {
        await Promise.all([
            i18next.loadNamespaces('EvpThemeBundle'),
            await new Promise((resolve) => {
                jquery(document).ready(resolve);
            }),
        ]);
    } catch (error) {
        logger.captureException(error);
    }

    const t = i18next.getFixedT(null, 'EvpThemeBundle');

    return createAxiosResponseInterceptor(
        new GoogleRecaptcha(
            i18next.language,
            null,
            '#recaptcha-modal .recaptcha-content'
        ),
        (error) => ({
            siteKey: error.response.headers['g-recaptcha-key'],
            unlockUrl: error.response.headers['recaptcha-unlock-url'],
        }),
        (error) => (
            error.response !== null
            && typeof error.response === 'object'
            && error.response.status === 429
            && error.response.headers !== null
            && typeof error.response.headers === 'object'
            && typeof error.response.headers['g-recaptcha-key'] !== 'undefined'
        ),
        (response, unlockUrl) => (
            axios.create({
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).post(
                unlockUrl,
                'g-recaptcha-response=' + encodeURIComponent(response.response)
            )
        ),
        '#recaptcha-modal',
        '#recaptcha-modal .recaptcha-loader',
        `
            <div class="modal fade recaptcha"
                role="dialog"
                id="recaptcha-modal"
                data-backdrop="static"
            >
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title">${t('recaptcha.title')}</h4>
                        </div>
                        <div class="modal-body">
                            <p>${t('recaptcha.description')}</p>
                            <div class="recaptcha-content"></div>
                            <div class="recaptcha-loader hidden">
                                <span class="spinner x3"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `,
    )
};

export default createInterceptor();
